import React from 'react';
import { Card, CardContent, Typography, Icon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    overflow: 'initial',
  },
  cardIcon: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.getContrastText(theme.palette.primary.main),
    borderRadius: '4px',
    position: 'absolute',
    top: theme.spacing(-4),
    left: theme.spacing(3),
  },
  cardContent: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const StatisticsCard = ({ heading, stat, icon }) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <div className={classes.cardIcon}>
        <Icon style={{ fontSize: '36px' }}>{icon}</Icon>
      </div>
      <CardContent className={classes.cardContent}>
        <Typography variant="overline">{heading || 'Some Heading'}</Typography>
        <Typography variant="h2">{stat || '60'}</Typography>
      </CardContent>
    </Card>
  );
};

export default StatisticsCard;
